// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceInvitation {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.email = model.email;
        this.createdAt = new Date(model.createdAt);
        this.resentAt = model.resentAt ? new Date(model.resentAt) : null;
        this.role = model.role;
        this.seatType = model.seatType;
        this.workspaceId = model.workspaceId;
        this.invitedBy = model.invitedBy;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toRemote() {
        var _a;
        return {
            id: this.id,
            email: this.email,
            createdAt: this.createdAt.toISOString(),
            resentAt: (_a = this.resentAt) === null || _a === void 0 ? void 0 : _a.toISOString(),
            role: this.role,
            seatType: this.seatType,
            workspaceId: this.workspaceId,
            invitedBy: this.invitedBy,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new WorkspaceInvitation(model);
    }
}
